import axios from "axios";
import { api } from "./api_route";

export const getCaseDashboardData = async (userId, orgIds, year, chartYear) => {
  const response = await axios.get(`${api}/dashboard/caseCount/${userId}`, {
    params: { orgIds, year, chartYear },
  });
  return response.data;
};
